// extracted by mini-css-extract-plugin
export default {"form":"EditPaymentRequest-module__form--PMXy4"};